"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prependHeaderToStream = exports.extractHeaderFromStream = void 0;
const buffer_array = __importStar(require("./buffer-array"));
const bson = __importStar(require("bson"));
const extractHeaderFromStream = async (input_stream, params) => {
    const iterator = input_stream[Symbol.asyncIterator]();
    const buffer = buffer_array.createReadableBufferArray();
    let frame_size = null;
    async function* resplice(data, iterator) {
        if (data) {
            yield data;
        }
        while (true) {
            const next = await iterator.next();
            if (next.done) {
                return;
            }
            yield next.value;
        }
    }
    while (true) {
        const chunk = await iterator.next();
        if (chunk.done) {
            throw new Error('Stream did not complete successfully');
        }
        buffer.push(chunk.value);
        if (frame_size === null) {
            frame_size = buffer.peek(4)?.readInt32LE(0) || null;
        }
        if (frame_size === null) {
            continue;
        }
        const frame = buffer.read(frame_size);
        if (!frame) {
            continue;
        }
        const header = bson.deserialize(frame, {
            promoteBuffers: true,
            ...(params?.deserialize_options || {})
        });
        return {
            header: header,
            stream: resplice(buffer.read(buffer.size()), iterator)
        };
    }
};
exports.extractHeaderFromStream = extractHeaderFromStream;
async function* prependHeaderToStream(header, input_stream) {
    yield bson.serialize(header);
    yield* input_stream;
}
exports.prependHeaderToStream = prependHeaderToStream;
